import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

/**
 * Painel de filtros recolhível (anima altura aberto/fechado).
 *
 * **Quando usar:** abaixo do `TitleBox` na mesma página. O estado aberto/fechado é
 * controlado pela tela pai (`[aberto]` + `(abertoChange)` ou two-way binding) — este
 * componente não persiste filtros nem chama API.
 *
 * **Conteúdo:** projete os campos (`<div>` com `mat-form-field`, toggles, etc.) no
 * conteúdo projetado do componente. O botão “Filtrar” dentro do painel dispara
 * `aplicarFiltro` para a página disparar nova consulta ao servidor.
 *
 * @see TitleBoxComponent Botão “Filtrar resultados” no título costuma sincronizar com `aberto`
 */
@Component({
  selector: 'app-filter-box',
  templateUrl: './filter-box.component.html',
  styleUrls: ['./filter-box.component.scss'],
  animations: [
    trigger('expandir', [
      state(
        'fechado',
        style({
          height: '0',
          opacity: 0,
          overflow: 'hidden',
        })
      ),
      state(
        'aberto',
        style({
          height: '*',
          opacity: 1,
          overflow: 'hidden',
        })
      ),
      transition('fechado <=> aberto', animate('280ms ease')),
    ]),
  ],
})
export class FilterBoxComponent {
  /** Se o painel está visível; combine com `(abertoChange)` ou `[(aberto)]`. */
  @Input() aberto = false;

  @Output() abertoChange = new EventEmitter<boolean>();

  /** Clique no botão “Filtrar” dentro do painel — típico: recarregar lista na página pai. */
  @Output() aplicarFiltro = new EventEmitter<void>();

  estadoAnimacao(): 'aberto' | 'fechado' {
    return this.aberto ? 'aberto' : 'fechado';
  }

  abrir(): void {
    if (!this.aberto) {
      this.abertoChange.emit(true);
    }
  }

  fechar(): void {
    if (this.aberto) {
      this.abertoChange.emit(false);
    }
  }

  alternar(): void {
    this.abertoChange.emit(!this.aberto);
  }

  onAplicar(): void {
    this.aplicarFiltro.emit();
  }
}
